export default {
      id: "logo_menu_fixe-usage",
      viewBox: "0 0 178 40",
      url: "../dist/images/" + "sprite.svg#logo_menu_fixe-usage",
      toString: function () {
        return this.url;
      }
    }